import {
  ADD_NEW_CONNECTOR,
  ADD_NEW_ENDPOINT,
  ADD_NEW_SALESFORCE_CONNECTOR,
  ADD_NEW_DYNAMO_CONNECTOR,
  ADD_NEW_STARTING_POINT,
  CLEAR_PREVIEW_DATA,
  CLEAR_STATIC_ENDPOINTS_DATA,
  DELETE_CONNECTOR,
  DELETE_ENDPOINT,
  DELETE_SALESFORCE_CONNECTOR,
  DELETE_DYNAMO_CONNECTOR,
  DELETE_STARTING_POINT,
  DELETE_STATIC_ENDPOINT,
  GET_CONNECTOR_DATA,
  GET_PREVIEW_DATA,
  GET_SALESFORCE_NEW_CONNECTOR_DATA,
  GET_DYNAMO_NEW_CONNECTOR_DATA,
  HIDE_CONNECTOR_MODAL,
  HIDE_ENDPOINT_MODAL,
  HIDE_STARTING_POINT_MODAL,
  SET_CONNECTOR_DATA,
  SET_DISABLE_DURING_REQUEST,
  SET_ENDPOINT_ENTRY_COLUMNS,
  SET_NEW_SALESFORCE_STATIC_ENDPOINTS_DATA,
  SET_NEW_DYNAMO_STATIC_ENDPOINTS_DATA,
  SET_PITCH_BOOK_ENDPOINTS,
  SET_SALESFORCE_ENDPOINT_PREVIEW,
  SET_STATIC_ENDPOINTS_DATA,
  SHOW_CONNECTOR_MODAL,
  SHOW_ENDPOINT_MODAL,
  SHOW_STARTING_POINT_MODAL,
  TOGGLE_CONNECTOR_DATA,
  TOGGLE_CONNECTOR_MODAL,
  TOGGLE_ENDPOINT_DATA,
  TOGGLE_ENDPOINT_MODAL,
  TOGGLE_PREVIEW,
  TOGGLE_STARTING_POINT_DATA,
  TOGGLE_STARTING_POINT_MODAL,
  UPDATE_CONNECTOR,
  UPDATE_ENDPOINT,
  UPDATE_STARTING_POINT,
  UPDATE_STATIC_ENDPOINT,
  GET_DYNAMO_CONNECTOR_LIST,
  SET_ENDPOINT_CONFIG_MODAL_STATE,
  SET_ENDPOINT_CONFIG,
  SET_DYNAMO_ENDPOINT_CONFIG_MODAL_STATE,
  SET_DYNAMO_DESCRIPTION_SCHEMA_MODAL_STATE,
  UPDATE_DYNAMO_ENDPOINT,
  UPDATE_DYNAMO_SCHEMA,
  UPDATE_DYNAMO_ENDPOINT_CONFIG,
  ADD_ELEMENT_TO_ENDPOINT_CONFIG,
  REMOVE_ELEMENT_TO_ENDPOINT_CONFIG,
  SET_LOADING_STATE,
  SET_PREVIEW,
  SET_READ_ENABLED_STATE_FOR_ALL_SCHEMAS,
  UPDATE_READ_ONLY_ENABLED_FIELDS,
  SET_PREVIEW_LOADING,
  RESET_DYNAMO_STATE,
} from './mutation-types';

export default {
  [SHOW_CONNECTOR_MODAL](state, data) {
    state.connectorModal.show = true;
    state.connectorModal.data = data;
  },
  [SET_CONNECTOR_DATA](state, data) {
    state.connector = data;
  },
  [HIDE_CONNECTOR_MODAL](state) {
    state.connectorModal.show = false;
    state.connectorModal.data = {};
  },
  [TOGGLE_CONNECTOR_MODAL](state, param) {
    state.connectorModal.loading = param;
  },
  [GET_CONNECTOR_DATA](state, data) {
    state.connectors = [...data];
  },
  [GET_SALESFORCE_NEW_CONNECTOR_DATA](state, data) {
    state.salesforceNewConnectors = [...data];
  },
  [GET_DYNAMO_NEW_CONNECTOR_DATA](state, data) {
    state.dynamoNewConnectors = [...data];
  },
  [TOGGLE_CONNECTOR_DATA](state, param) {
    state.loading = param;
  },
  [ADD_NEW_CONNECTOR](state, data) {
    state.connectors.push(data);
  },
  [ADD_NEW_SALESFORCE_CONNECTOR](state, data) {
    state.salesforceNewConnectors.push(data);
  },
  [ADD_NEW_DYNAMO_CONNECTOR](state, data) {
    state.dynamoNewConnectors.push(data);
  },
  [UPDATE_CONNECTOR](state, data) {
    const index = state.connectors.findIndex(c => c.configurationId === data.configurationId);
    state.connectors[index] = {...data};
    state.connectors = [...state.connectors];
  },
  [DELETE_CONNECTOR](state, configurationId) {
    state.connectors = [...state.connectors.filter(c => c.configurationId !== configurationId)];
  },
  [DELETE_SALESFORCE_CONNECTOR](state, configurationId) {
    state.salesforceNewConnectors = [...state.salesforceNewConnectors.filter(c => c.connectorInstanceId !== configurationId)];
  },
  [DELETE_DYNAMO_CONNECTOR](state, configurationId) {
    state.dynamoNewConnectors = [...state.dynamoNewConnectors.filter(c => c.connectorInstanceId !== configurationId)];
  },
  [SHOW_ENDPOINT_MODAL](state, data) {
    state.endpoint.modal.show = true;
    state.endpoint.modal.data = data;
  },
  [HIDE_ENDPOINT_MODAL](state) {
    state.endpoint.modal.show = false;
    state.endpoint.modal.data = {};
  },
  [ADD_NEW_ENDPOINT](state, data) {
    const connectorIndex = state.connectors.findIndex(c => c.configurationId === data.configurationId);
    state.connectors[connectorIndex].endpoints.push(data);
  },
  [UPDATE_ENDPOINT](state, data) {
    const connectorIndex = state.connectors.findIndex(c => c.configurationId === data.configurationId);
    const endpointIndex = state.connectors[connectorIndex].endpoints.findIndex(e => e.endpointId === data.endpointId);
    state.connectors[connectorIndex].endpoints[endpointIndex] = {...data};
    state.connectors = [...state.connectors];
  },
  [DELETE_ENDPOINT](state, data) {
    const connectorIndex = state.connectors.findIndex(c => c.configurationId === data.configurationId);
    state.connectors[connectorIndex].endpoints = [...state.connectors[connectorIndex].endpoints.filter(e => e.endpointId !== data.endpointId)];
    state.connectors = [...state.connectors];
  },
  [TOGGLE_ENDPOINT_DATA](state, param) {
    state.endpoint.loading = param;
  },
  [TOGGLE_ENDPOINT_MODAL](state, param) {
    state.endpoint.modal.loading = param;
  },
  [TOGGLE_PREVIEW](state, param) {
    state.preview.loading = param;
    state.salesforceNewPreview.loading = param;
  },
  [GET_PREVIEW_DATA](state, data) {
    state.preview.data = data;
  },
  [CLEAR_PREVIEW_DATA](state) {
    state.preview.data = [];
  },
  [SHOW_STARTING_POINT_MODAL](state, data) {
    state.startingPoint.modal.show = true;
    state.startingPoint.modal.data = data;
  },
  [HIDE_STARTING_POINT_MODAL](state) {
    state.startingPoint.modal.show = false;
    state.startingPoint.modal.data = {};
  },
  [TOGGLE_STARTING_POINT_MODAL](state, param) {
    state.startingPoint.modal.loading = param;
  },
  [TOGGLE_STARTING_POINT_DATA](state, param) {
    state.startingPoint.loading = param;
  },
  [ADD_NEW_STARTING_POINT](state, data) {
    const connectorIndex = state.connectors.findIndex(c => c.configurationId === data.configurationId);
    state.connectors[connectorIndex].startingPoints = {
      ...state.connectors[connectorIndex].startingPoints,
      [data.startingPointId]: {...data},
    };
    state.connectors = [...state.connectors];
  },
  [UPDATE_STARTING_POINT](state, data) {
    const connectorIndex = state.connectors.findIndex(c => c.configurationId === data.configurationId);
    state.connectors[connectorIndex].startingPoints[data.startingPointId] = {...data};
    state.connectors = [...state.connectors];
  },
  [DELETE_STARTING_POINT](state, data) {
    const connectorIndex = state.connectors.findIndex(c => c.configurationId === data.configurationId);
    delete state.connectors[connectorIndex].startingPoints[data.startingPointId];
    state.connectors = [...state.connectors];
  },
  [SET_PITCH_BOOK_ENDPOINTS](state, params) {
    if (params.keyMap) {
      let pitchBookEndpoints = [];
      Object.keys(params.data).forEach(endpointType => pitchBookEndpoints = {...pitchBookEndpoints, ...params.data[endpointType]});

      state.startingPoint.pitchBookEndpoints = pitchBookEndpoints;
    } else {
      state.startingPoint.pitchBookEndpoints = {...params.data};
    }
  },
  [SET_STATIC_ENDPOINTS_DATA](state, {data, isEfront, endpoints}) {

    const endpointsMap = new Map();
    if (isEfront) {
      endpoints.forEach(e => {
        endpointsMap.set(e.entityName, e);
      });
    }

    state.staticEndpoints.data = data.map((i, index) => {
      let item = {...i, index};
      if (isEfront) {
        const {endpointId} = endpointsMap.get(i.originalName) || {};
        if (endpointId) {
          item = {...item, endpointId};
        }
      }
      return item;
    });
  },
  [SET_NEW_SALESFORCE_STATIC_ENDPOINTS_DATA](state, {data}) {
    state.salesforceNewStaticEndpoints.data = data.map((i, index) => {
      return {...i, index};
    });
  },
  [SET_NEW_SALESFORCE_STATIC_ENDPOINTS_DATA](state, {data}) {
    state.dynamoNewStaticEndpoints.data = data.map((i, index) => {
      return {...i, index};
    });
  },
  [UPDATE_STATIC_ENDPOINT](state, endpoint) {
    state.staticEndpoints.data[endpoint.index].endpointId = endpoint.endpointId;
  },
  [DELETE_STATIC_ENDPOINT](state, endpoint) {
    state.staticEndpoints.data[endpoint.index].endpointId = '';
  },
  [CLEAR_STATIC_ENDPOINTS_DATA](state) {
    state.staticEndpoints.data = [];
  },
  [SET_ENDPOINT_ENTRY_COLUMNS](state, endpointColumnMap) {
    state.endpointEntryColumns = endpointColumnMap;
  },
  [SET_SALESFORCE_ENDPOINT_PREVIEW](state, endpointPreviewData) {
    state.salesforceNewPreview.data = endpointPreviewData;
  },
  [SET_DISABLE_DURING_REQUEST](state, isDisabled) {
    state.disableDuringRequest = isDisabled;
  },
  [GET_DYNAMO_CONNECTOR_LIST](state, payload) {
    state.dynamoConnectorsList = payload;
  },
  [SET_ENDPOINT_CONFIG_MODAL_STATE](state, payload) {
    state.endpointConfigurationModal = payload;
  },
  [SET_ENDPOINT_CONFIG](state, payload) {
    state.dynamoEndpointsConfig = payload;
  },
  [ADD_ELEMENT_TO_ENDPOINT_CONFIG](state, payload) {
    state.dynamoConnectorsList = state.dynamoConnectorsList.map(el => {
      return el.label === payload.endpointName
        ? {...el, endpointGuid: payload.endpointGuid}
        : el;
    });
    state.dynamoEndpointsConfig.endpointConfigs.push(payload);
  },
  [REMOVE_ELEMENT_TO_ENDPOINT_CONFIG](state, id) {
    state.dynamoEndpointsConfig.endpointConfigs = state.dynamoEndpointsConfig.endpointConfigs.filter(el => {
      return el.endpointGuid !== id;
    });
    state.dynamoConnectorsList = state.dynamoConnectorsList.map(el => {
      return el.endpointGuid === id
        ? {...el, isAdded: false}
        : el;
    });
  },
  [SET_DYNAMO_ENDPOINT_CONFIG_MODAL_STATE](state, payload) {
    if (payload.data) {
      const fieldSchemas = payload.data.fieldSchemas.map(el => ({
        ...el,
        isReadEnabled: el.isBusinessKey || el.isReadEnabled,
      }));
      state.dynamoEndpointConfigurationModal = {
        ...payload,
        data: {
          ...payload.data,
          fieldSchemas,
        },
      };
    } else {
      state.dynamoEndpointConfigurationModal = payload;
    }

  },
  [SET_DYNAMO_DESCRIPTION_SCHEMA_MODAL_STATE](state, payload) {
    state.dynamoDescriptionSchemaModal = payload;
  },
  [UPDATE_DYNAMO_ENDPOINT](state, payload) {
    state.dynamoEndpointsConfig.endpointConfigs = state.dynamoEndpointsConfig.endpointConfigs.map(el => {
      return el.endpointGuid === payload.endpointGuid ? payload : el;
    });
  },
  [UPDATE_DYNAMO_SCHEMA](state, payload) {
    state.dynamoEndpointConfigurationModal.data.fieldSchemas = state.dynamoEndpointConfigurationModal.data.fieldSchemas.map(el => {
      if (el.columnName === payload.columnName) {
        return {
          ...el,
          ...payload,
        };
      }
      return el;
    });
  },
  [UPDATE_DYNAMO_ENDPOINT_CONFIG](state, payload) {
    state.dynamoEndpointConfigurationModal.data = {
      ...payload,
      fieldSchemas: state.dynamoEndpointConfigurationModal.data.fieldSchemas,
    };
  },
  [SET_LOADING_STATE](state, payload) {
    state.loadingDuringAdding = payload;
  },
  [SET_PREVIEW](state, payload) {
    if (!payload) {
      state.dynamoPreview = {
        entityLabel: null,
        data: null,
      };
    } else {
      const label = state.dynamoEndpointsConfig.endpointConfigs.find(el => (
        el.endpointGuid === payload.endpointId
      ));
      state.dynamoPreview = {
        entityLabel: label.dynamoLabel,
        data: payload.body,
      };
    }
  },
  [SET_READ_ENABLED_STATE_FOR_ALL_SCHEMAS](state, payload) {
    state.isAllSchemasWithReadEnabled = payload;
    state.dynamoEndpointConfigurationModal.data.fieldSchemas = state.dynamoEndpointConfigurationModal.data.fieldSchemas.map(el => {
      return el.isBusinessKey ? el : {...el, isReadEnabled: payload};
    });
  },
  [UPDATE_READ_ONLY_ENABLED_FIELDS](state, payload) {
    state.isAllSchemasWithReadEnabled = payload;
  },
  [SET_PREVIEW_LOADING](state, payload) {
    state.isPreviewLoading = payload;
  },
  [RESET_DYNAMO_STATE](state) {
    state.dynamoConnectorsList = null;
    state.dynamoEndpointsConfig = null;
    state.dynamoPreview = {
      entityLabel: null,
      data: null,
    };
  },
};
